export const APP_VERSION: string = '1.3.0';
